import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import { type CustomItemComponentProps, VList } from 'virtua';
import { ContactListItem } from '@/components/contacts/contact-list/contact-list-item';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useFriendInfo from '@/hooks/users/use-friend-info';
import ROUTES from '@/routes';

const Item = forwardRef<HTMLDivElement, CustomItemComponentProps>(({ index, style, children }, ref) => (
  <div
    style={style}
    key={index}
    ref={ref}
    className='border-b border-metal-50 last:border-b-0'>
    {children}
  </div>
));

export default function CommonGroupsRoute() {
  const { t } = useTranslation();
  const { userId } = useTypedParams(ROUTES.CONTACT.USERS.BY_ID);
  const { friendInfo, isLoading } = useFriendInfo(userId);

  const commonGroups = friendInfo?.CommonGroup ?? [];

  return (
    <PageLayout
      title={t('user.same-group')}
      headerConfig={{
        navigateBack: true,
      }}>
      <LoadingLayout promise={isLoading}>
        {() => (
          <VList
            overscan={6}
            itemSize={64}
            className='flex-1 pb-safe'
            item={Item}>
            {commonGroups.map((group) => (
              <Link
                key={group.ID}
                to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: group.ID } })}>
                <ContactListItem
                  item={group}
                  arrow
                />
              </Link>
            ))}
          </VList>
        )}
      </LoadingLayout>
    </PageLayout>
  );
}
